import React from "react"
import {
    compose,
    convertFromErrorObject,
    getAllModalFunctions,
    removeEmptyFromObject,
} from "../../../utils"
import { withTranslation } from "react-i18next"
import { withTLService } from "../../hoc"
import { connect } from "react-redux"
import { Button } from "react-bootstrap"
import DataViewer from "../../elements/data-viewer"
import { bindActionCreators } from "redux"
import ModalAddEditTaskCron from "../../modals/modal-add-edit-task-cron"

class TaskCron extends DataViewer {

    modalWindowsCount = 2

    tableFilters = {}

    functions = {
        getAll: (token) => this.props.tlService.getTaskTypeCron(token),
        massDelete: data => this.actionMassDelete(data),
    }

    modalComponents = {
        modalAdd: ModalAddEditTaskCron,
        modalEdit: ModalAddEditTaskCron,
    }

    async componentDidMount() {
        const {
            userData: { user },
            t: translate,
        } = this.props

        this.columns_default = [
            {
                name: 'id',
                selector: 'id',
            },
            {
                name: 'name',
                selector: 'name',
            },
            {
                name: 'cron',
                selector: 'cron',
            },
            {
                name: 'settings',
                selector: 'settings',
                cell: row => {
                    const content = typeof row.settings === 'string' ? row.settings : JSON.stringify(row.settings)
                    return content && content.length > 60 ? `${content.substring(0, 60)}...` : content
                },
            },
            {
                name: 'edit',
                cell: row => (
                    <div className="btn-group">
                        <Button onClick={() => this.openModal(0, row, 'modalEdit')} className="ml-2"><i className="fas fa-edit" /></Button>
                        <Button onClick={() => this.openModal(0, row, 'modalDelete')} className="ml-2"><i className="fas fa-trash" /></Button>
                    </div>
                ),
            },
        ]

        this.renderIt = (user?.user_type_id === 1)
        this.addButton = (user?.user_type_id === 1)

        this.modalSettings['modalAdd'] = {
            action: this.actionAdd,
            data: {
                name: '',
                cron: '',
                settings: '{}',
            },
            show: false,
            header: translate('Add Task Cron'),
            footer: true,
            text: '',
            saveButton: true,
            saveButtonText: translate('Save'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true,
        }

        this.modalSettings['modalEdit'] = {
            action: this.actionEdit,
            data: {
                name: '',
                cron: '',
                settings: '{}',
            },
            show: false,
            header: translate('Edit Task Cron'),
            footer: true,
            text: '',
            saveButton: true,
            saveButtonText: translate('Save'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true,
        }

        this.modalSettings['modalDelete'] = {
            action: this.actionDelete,
            data: {
                id: '',
            },
            show: false,
            header: translate('Delete Task Cron'),
            footer: true,
            text: translate('Delete Task Cron?'),
            saveButton: true,
            saveButtonText: translate('Delete'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true,
        }

        this.modalSettings['modalMassDelete'] = {
            action: this.actionDoMassDelete,
            data: {},
            show: false,
            header: translate('Delete Task Crons'),
            footer: true,
            text: translate('Delete selected Task Crons?'),
            saveButton: true,
            saveButtonText: translate('Delete'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true,
        }

        this.setState({
            filters: {},
            limits: {
                limit: 100,
                offset: 0,
                order_by: 'id',
                order: 0,
            },
            page: {
                pageHeader: translate('Task Cron Management'),
                addNewText: translate('Add new cron'),
            },
        })

        super.componentDidMount()
    }

    validateCron = (value) => {
        const { t: translate } = this.props

        if (!value || !value.trim()) {
            return { valid: false, message: translate('Cron expression is required') }
        }

        const parts = value.trim().split(/\s+/)
        if (parts.length !== 6) {
            return { valid: false, message: translate('Cron expression must contain 6 parts separated by spaces') }
        }

        return { valid: true }
    }

    actionAdd = async (data) => {
        const { t: translate } = this.props
        const {
            tlService,
            userData: { token },
        } = this.props

        const cronValidation = this.validateCron(data.cron)
        if (!cronValidation.valid) {
            this.setState({ error: cronValidation.message })
            return false
        }

        if (typeof data.settings !== "object") {
            try {
                data.settings = JSON.parse(data.settings)
            } catch (e) {
                data.settings = {}
            }
        }

        let payload
        try {
            payload = {
                name: data.name,
                cron: data.cron,
                settings: data.settings ? removeEmptyFromObject(data.settings) : {},
                
            }
        } catch (error) {
            this.setState({ error: translate('Settings must be valid JSON') })
            return false
        }

        try {
            await tlService.addTaskTypeCron(token, payload)
        } catch (error) {
            this.setState({ error: convertFromErrorObject(translate, error) })
            return false
        }

        return true
    }

    actionEdit = async (data) => {
        const { t: translate } = this.props
        const {
            tlService,
            userData: { token },
        } = this.props

        const numericId = parseInt(data.id, 10)
        if (Number.isNaN(numericId)) {
            this.setState({ error: translate('Task cron ID must be a number') })
            return false
        }

        const cronValidation = this.validateCron(data.cron)
        if (!cronValidation.valid) {
            this.setState({ error: cronValidation.message })
            return false
        }

        if (typeof data.settings !== "object") {
            try {
                data.settings = JSON.parse(data.settings)
            } catch (e) {
                data.settings = {}
            }
        }

        let payload
        try {
            payload = {
                name: data.name,
                cron: data.cron,
                settings: data.settings ? removeEmptyFromObject(data.settings) : {},
            }
        } catch (error) {
            this.setState({ error: translate('Settings must be valid JSON') })
            return false
        }

        try {
            await tlService.updateTaskTypeCron(token, numericId, payload)
        } catch (error) {
            this.setState({ error: convertFromErrorObject(translate, error) })
            return false
        }

        return true
    }

    actionDelete = async (data) => {
        const { t: translate } = this.props
        const {
            tlService,
            userData: { token },
        } = this.props

        const numericId = parseInt(data.id, 10)
        if (Number.isNaN(numericId)) {
            this.setState({ error: translate('Task cron ID must be a number') })
            return false
        }

        try {
            await tlService.deleteTaskTypeCron(token, numericId)
        } catch (error) {
            this.setState({ error: convertFromErrorObject(translate, error) })
            return false
        }

        return true
    }
}

const mapStateToProps = ({ userData, modalData, openData }) => {
    return { userData, openData, modalData }
}

const mapDispatchToProps = (dispatch, { tlService }) => {
    return bindActionCreators({
        ...getAllModalFunctions(),
    }, dispatch)
}

export default compose(
    withTranslation(),
    withTLService(),
    connect(mapStateToProps, mapDispatchToProps)
)(TaskCron)
